// extracted by mini-css-extract-plugin
export var hideEditor = "_ku-2";
export var infoIcon = "_ku-3";
export var label = "_ku-1";
export var labelContainer = "_ku-0";
export var readonlyText = "_ku-4";